import update from 'immutability-helper';

import initialState from 'store/initialState';
import { createReducer } from 'store/reduxTools';
import {
  NOTIF_SET_ADMIN_LATEST,
  NOTIF_SET_ADMIN_DATA,
  NOTIF_SET_ADMIN_UNREAD,
  NOTIF_SET_ADMIN_PAGINATED_DATA,
  NOTIF_SET_ADMIN_CURRENT_PAGE,
  NOTIF_SET_ADMIN_LAST_PAGE,
  NOTIF_SET_ADMIN_SCROLL_POSITION,
  NOTIF_SET_USER_LATEST,
  NOTIF_SET_USER_DATA,
  NOTIF_SET_USER_UNREAD,
  NOTIF_SET_USER_PAGINATED_DATA,
  NOTIF_SET_USER_CURRENT_PAGE,
  NOTIF_SET_USER_LAST_PAGE,
  NOTIF_CLEAR_USER_PAGINATED,
  NOTIF_SET_USER_SCROLL_POSITION,
} from 'store/types';

export default createReducer(initialState, {
  [NOTIF_SET_ADMIN_LATEST]: (state, action) => setAdminLatest(state, action.payload),
  [NOTIF_SET_ADMIN_DATA]: (state, action) => setAdminData(state, action.payload),
  [NOTIF_SET_ADMIN_UNREAD]: (state, action) => setAdminUnread(state, action.payload),
  [NOTIF_SET_ADMIN_PAGINATED_DATA]: (state, action) => setAdminPaginatedData(state, action.payload),
  [NOTIF_SET_ADMIN_CURRENT_PAGE]: (state, action) => setAdminCurrentPage(state, action.payload),
  [NOTIF_SET_ADMIN_LAST_PAGE]: (state, action) => setAdminLastPage(state, action.payload),
  [NOTIF_SET_ADMIN_SCROLL_POSITION]: (state, action) => setAdminScrollPosition(state, action.payload),
  [NOTIF_SET_USER_LATEST]: (state, action) => setUserLatest(state, action.payload),
  [NOTIF_SET_USER_DATA]: (state, action) => setUserData(state, action.payload),
  [NOTIF_SET_USER_UNREAD]: (state, action) => setUserUnread(state, action.payload),
  [NOTIF_SET_USER_PAGINATED_DATA]: (state, action) => setUserPaginatedData(state, action.payload),
  [NOTIF_SET_USER_CURRENT_PAGE]: (state, action) => setUserCurrentPage(state, action.payload),
  [NOTIF_SET_USER_LAST_PAGE]: (state, action) => setUserLastPage(state, action.payload),
  [NOTIF_CLEAR_USER_PAGINATED]: (state) => clearUserPaginated(state),
  [NOTIF_SET_USER_SCROLL_POSITION]: (state, action) => setUserScrollPosition(state, action.payload),
});

const setAdminLatest = (state, payload) => {
  return update(state, {
    adminNotif: {
      latest: { $set: payload },
    },
  });
};

const setAdminData = (state, payload) => {
  const { data, pagination } = payload;

  return update(state, {
    adminNotif: {
      data: { $set: data },
      pagination: { $set: pagination },
    },
  });
};

const setAdminUnread = (state, payload) => {
  return update(state, {
    adminNotif: {
      unread: { $set: payload },
    },
  });
};

const setAdminPaginatedData = (state, payload) => {
  return update(state, {
    adminNotif: {
      paginatedData: { $set: payload },
    },
  });
};

const setAdminCurrentPage = (state, payload) => {
  return update(state, {
    adminNotif: {
      currentPage: { $set: payload },
    },
  });
};

const setAdminLastPage = (state, payload) => {
  return update(state, {
    adminNotif: {
      lastPage: { $set: payload },
    },
  });
};

const setAdminScrollPosition = (state, payload) => {
  return update(state, {
    adminNotif: {
      scrollPosition: { $set: payload },
    },
  });
};

const setUserLatest = (state, payload) => {
  return update(state, {
    userNotif: {
      latest: { $set: payload },
    },
  });
};

const setUserData = (state, payload) => {
  const { data, pagination } = payload;

  return update(state, {
    userNotif: {
      data: { $set: data },
      pagination: { $set: pagination },
    },
  });
};

const setUserUnread = (state, payload) => {
  return update(state, {
    userNotif: {
      unread: { $set: payload },
    },
  });
};

const setUserPaginatedData = (state, payload) => {
  return update(state, {
    userNotif: {
      paginatedData: { $set: payload },
    },
  });
};

const setUserCurrentPage = (state, payload) => {
  return update(state, {
    userNotif: {
      currentPage: { $set: payload },
    },
  });
};

const setUserLastPage = (state, payload) => {
  return update(state, {
    userNotif: {
      lastPage: { $set: payload },
    },
  });
};

const clearUserPaginated = (state) => {
  return update(state, {
    userNotif: {
      paginatedData: { $set: [] },
      currentPage: { $set: 1 },
      lastPage: { $set: 1 },
    },
  });
};

const setUserScrollPosition = (state, payload) => {
  return update(state, {
    userNotif: {
      scrollPosition: { $set: payload },
    },
  });
};
